import { render } from "./CommercialCorporateSidebar.vue?vue&type=template&id=4c9107e2&ts=true"
import script from "./CommercialCorporateSidebar.vue?vue&type=script&lang=ts"
export * from "./CommercialCorporateSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__